module.exports = __webpack_public_path__ + "img/feature_buy_en.21d02b04.png";